"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectContext = void 0;

var React = _interopRequireWildcard(require("react"));

var SelectContext = /*#__PURE__*/React.createContext(null);
exports.SelectContext = SelectContext;


//////////////////
// WEBPACK FOOTER
// ./~/rc-tree-select/lib/Context.js
// module id = 1914
// module chunks = 0